import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";
import type { ResourceContactType } from "shared/types/outreach";

import type ContactMailingList from "./ContactMailingList";

@Model()
class ContactMailingListsContact extends ApplicationRecord {
  static jsonapiType = "contact_mailing_lists_contacts";

  @Attr({ persist: false }) avatarUrl: string;

  @BelongsTo() contact: ResourceContactType;

  @Attr() contactId: string;

  @BelongsTo() contactMailingList: ContactMailingList;

  @Attr() contactMailingListId: number;

  @Attr() contactType: string;

  @Attr({ persist: false }) email: string;

  @Attr({ persist: false }) name: string;
}

export default ContactMailingListsContact;
